import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { hasTimerDuration } from '@mummssoftware/utils/utils';
import { makeStyles } from '@material-ui/core/styles';
import { VisitLogContext } from '../../Context/VisitLogContext';
import defaults from '../../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

type EditVisitButtonsProps = {
  setClosed: () => void;
  onEdit: () => void;
};

export const EditVisitButtons = ({
  setClosed,
  onEdit,
}: EditVisitButtonsProps) => {
  const classes = useStyles();
  const { changeDetail } = useContext(VisitLogContext);

  const handleClick = () => {
    setClosed && setClosed();
  };
  const {
    travelMileage,
    transitFees,
    travelDuration,
    tollsFee,
    editTime,
    ccTime,
    timerDuration,
    startTime,
  } = useContext(VisitsGlobalContext);
  const { isVisitEdited } = useContext(VisitLogContext);

  const active =
    changeDetail ||
    travelMileage ||
    transitFees ||
    travelDuration ||
    tollsFee ||
    editTime ||
    startTime ||
    ccTime ||
    isVisitEdited ||
    hasTimerDuration(timerDuration);
  const canceltitle = active ? defaults.discardEdit : defaults.close;

  return (
    <div className={classes.buttonContainer}>
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={!active}
        onClick={onEdit}
      >
        {defaults.acceptChanges}
      </Button>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {canceltitle}
      </Button>
    </div>
  );
};
